import { render, staticRenderFns } from "./Avisos.vue?vue&type=template&id=1163a4d7&scoped=true&"
import script from "./Avisos.vue?vue&type=script&lang=ts&"
export * from "./Avisos.vue?vue&type=script&lang=ts&"
import style0 from "./Avisos.vue?vue&type=style&index=0&id=1163a4d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163a4d7",
  null
  
)

export default component.exports